import React from 'react';

/**
 * Small divider showing campaign name with colored accent.
 * Used to group missions by campaign in multi-campaign mode.
 */
const CampaignDivider = ({ campaign }) => (
  <div
    className="flowchart-hud__campaign-divider"
    style={{ '--campaign-color': campaign.color }}
  >
    <span className="flowchart-hud__campaign-divider-bar" />
    <span className="flowchart-hud__campaign-divider-name">{campaign.name}</span>
  </div>
);

export default CampaignDivider;
